const M = [
  {
    name: "mobileNumberManagement",
    zh: "手机号管理",
    en: "Mobile number management"
  },
  {
    name: "changeMobileNumber",
    zh: "更换手机号",
    en: "Change mobile number"
  },
  {
    name: "addMobileNumber",
    zh: "添加手机号",
    en: "Add mobile number"
  },
  {
    name: "modifyLoginPsd",
    zh: "修改登录密码",
    en: "Modify login password"
  },
  {
    name: "oldPsd",
    zh: "旧密码",
    en: "Old password"
  },
  {
    name: "newPsd",
    zh: "新密码",
    en: "New password"
  },
  {
    name: "paySet",
    zh: "支付设置",
    en: "Payment setting"
  },
  {
    name: "defaultPaymentSetting",
    zh: "扣款顺序选择",
    en: "Default payment setting"
  },
  {
    name: "thirdPartyLogin",
    zh: "第三方登录",
    en: "Third party login"
  },
  {
    name: "emailBinding",
    zh: "邮箱绑定",
    en: "Email binding"
  },
  {
    name: "unbound",
    zh: "未绑定",
    en: "Unbound"
  },
  {
    name: "securitySettings",
    zh: "密保设置",
    en: "Security setting"
  },
  {
    name: "enterEmailAddress",
    zh: "请输入邮箱地址",
    en: "Enter your email address"
  },
  {
    name: "emailResetPsdTips",
    zh: "您可以用验证过的邮箱来找回登录密码",
    en: "You can use the verified email to retrieve the login password"
  },
  {
    name: "securityQuestion",
    zh: "密保问题",
    en: "Security question"
  },
  {
    name: "securityVerification",
    zh: "密保验证",
    en: "Security verification"
  },
  {
    name: "newSecurityVerification",
    zh: "新密保设置",
    en: "New security setting"
  },
  {
    name: "change",
    zh: "更改",
    en: "Change"
  },
  {
    name: "selectQuestion",
    zh: "请选择问题",
    en: "Select the question"
  },
  {
    name: "questionNotRepeated",
    zh: "问题不能重复",
    en: "The question cannot be repeated"
  },
  {
    name: "question",
    zh: "问题",
    en: "Question"
  },
  {
    name: "answer",
    zh: "答案",
    en: "Answer"
  },
  {
    name: "enterAnswer",
    zh: "请输入答案",
    en: "Enter your answer"
  }
];

export default M;
